import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators.js';
import global_css from './global-css';
import {Modal} from './modal';
import {ri, RunnerIdle} from './runner-idle';
import {Plot} from './plot';
export default function () {
  // pause
  const settings = document.querySelector('ri-settings') as Settings;
  settings.oldGameSpeed = ri.gameSpeed;
  ri.gameSpeed = 0;
  if (settings) {
    const modal = settings.shadowRoot?.querySelector('ri-modal') as Modal;
    if (modal) {
      modal.open();
      (settings.shadowRoot?.getElementById('main-plot') as Plot)?.plot();
    }
  }
}

@customElement('ri-settings')
export class Settings extends LitElement {
  oldGameSpeed = 0;
  exportSave() {
    const textarea = this.shadowRoot?.getElementById(
      'export-save'
    ) as HTMLTextAreaElement;
    if (textarea) textarea.value = btoa(JSON.stringify(ri.saveGame));
  }

  importSave() {
    const textarea = this.shadowRoot?.getElementById(
      'import-save'
    ) as HTMLTextAreaElement;
    if (textarea) ri.load(JSON.parse(atob(textarea.value)));
  }

  close() {
    (this.shadowRoot?.querySelector('ri-modal') as Modal)?.close();
    this.unpause();
  }

  toggle(prop: 'darkMode' | 'showDetails' | 'lightEffects', force?: boolean) {
    ri.preferences[prop] = force ?? !ri.preferences[prop];
    ri.requestUpdate();
    this.requestUpdate();
  }

  unpause() {
    const runnerIdle = document.querySelector('runner-idle') as RunnerIdle;
    if (runnerIdle) {
      runnerIdle.gameSpeed = this.oldGameSpeed;
    }
  }

  static override styles = [
    global_css,
    css`
      * {
        transition: all 0.2s ease-in-out;
      }
      .modal {
        background-color: red;
      }
      button {
        background-color: #fff4;
      }

      .toggled {
        background-color: green;
        color: white;
      }
      .toggled:hover {
        background-color: darkgreen;
      }
    `,
  ];

  protected override render() {
    return html`
      <ri-modal .closeOnOverlay=${true} .onClose=${this.unpause}>
        <div class="container">
          <button @click=${this.exportSave}>Export Save</button>
          <button @click=${this.importSave}>Import Save</button>
          <button
            @click=${(_) => {
              if (
                window.confirm(
                  'Do you really want to delete your save? THIS IS IRREVERSIBLE.'
                )
              ) {
                document.querySelector('runner-idle')?.resetSave();
              }
            }}
            class="danger"
          >
            HARD RESET
          </button>
          <textarea readonly id="export-save"></textarea>
          <textarea id="import-save"></textarea>
          <button
            @click=${() => this.toggle('darkMode')}
            class="${ri.preferences.darkMode ? 'toggled' : ''}"
          >
            Dark Mode
          </button>
          <button
            @click=${() => this.toggle('lightEffects')}
            class="${ri.preferences.lightEffects ? 'toggled' : ''}"
          >
            Light affects background color
          </button>
          <button
            @click=${() => this.toggle('showDetails')}
            class="${ri.preferences.showDetails ? 'toggled' : ''}"
          >
            Show Detailed Calculations
          </button>
          <button @click=${this.close}>Close</button>
          <br />
          <button @click=${() => window.open('https://discord.gg/WS87ea4gQY')}>
            Discord
          </button>
          <ri-plot
            id="main-plot"
            .data=${ri.history}
            .keys=${ri
              ? [
                  'distance',
                  ...Object.keys(ri.stats).filter((s) => ri.stats[s].unlocked),
                  ...Object.keys(ri.resources).filter(
                    (r) => ri.resources[r].unlocked
                  ),
                ]
              : []}
          ></ri-plot>
        </div>
      </ri-modal>
    `;
  }
}
